// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lifts_wrapper__dvOqd","dot":"lifts_dot__f-kpK","dotRed":"lifts_dotRed__VKH7t","icon":"lifts_icon__HQtDC","paragraph":"lifts_paragraph__2T05w"};